// fastContext.ts
'use client';
import createFastContext from '../context/createFastContext';

export const { FastContextProvider:GlobalMicTabFastContextProvider, useFastContextFields: useGlobalMicTabContext } =
  createFastContext({
    openGlobalMicTab: 'false',
  });
